import { useQueryClient } from "react-query";
import useBuildingLoadingState from "recoilStore/useBuildingLoadingState";
import { useUpdateBuildingModelMutation } from "mutations/useUpdateBuildingModelMutation";
import { equipmentSurveyQueryKey } from "queries/Equipment/useEquipmentSurvey";
import { buildingQueryKey } from "ApiLayer/Building/queryBuildingModel";

export const useQueryOnStatusUpdate = (buildingModelUid: string) => {
    const queryClient = useQueryClient();
    const { setLoadingState } = useBuildingLoadingState(buildingModelUid);

    const reset = () => {
        setLoadingState((prev) => ({
            ...prev,
            buildingReportsLoading: false,
            energySidebarLoading: false,
            equipmentSidebarLoading: false,
        }));
        queryClient.resetQueries({
            queryKey: ["energyAggregation", buildingModelUid],
        });
        queryClient.resetQueries({
            queryKey: ["buildingModelUtilityData", buildingModelUid],
        });

        queryClient.resetQueries({
            queryKey: [buildingModelUid, "buildingModelReport"],
        });

        queryClient.invalidateQueries({
            queryKey: ["buildingModelHeader", buildingModelUid],
        });

        queryClient.invalidateQueries({
            queryKey: ["buildingModelsTable"],
        });

        queryClient.invalidateQueries({
            queryKey: [...buildingQueryKey, buildingModelUid],
        });

        queryClient.invalidateQueries({
            queryKey: [...equipmentSurveyQueryKey, buildingModelUid],
        });
    };

    return { onSuccess: reset, onError: reset };
};

export const useUpdateBuildingModel = (buildingModelUid: string) => {
    const { onSuccess, onError } = useEnergyTypeOnStatusUpdate(buildingModelUid);

    const { mutate: updateBuildingModel, error } = useUpdateBuildingModelMutation(buildingModelUid, onSuccess, onError);

    return { updateBuildingModel, error };
};

const useEnergyTypeOnStatusUpdate = (buildingModelUid: string) => {
    const queryClient = useQueryClient();
    const { setLoadingState } = useBuildingLoadingState(buildingModelUid);

    const reset = () => {
        setLoadingState((prev) => ({
            ...prev,
            constructionSidebarLoading: false,
            buildingReportsLoading: false,
        }));
        queryClient.resetQueries({
            queryKey: [buildingModelUid, "buildingModelReport"],
        });

        queryClient.resetQueries({
            queryKey: [buildingModelUid, "buildingModelConstruction"],
        });

        queryClient.invalidateQueries({
            queryKey: ["buildingModelHeader", buildingModelUid],
        });

        queryClient.invalidateQueries({
            queryKey: ["buildingModelsTable"],
        });

        queryClient.invalidateQueries({
            queryKey: [...buildingQueryKey, buildingModelUid],
        });
    };

    return { onSuccess: reset, onError: reset };
};
